import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { IconDatabaseImport, IconSparkles } from "@tabler/icons-react"; // Nuevos iconos

import styles from "./styles.module.css";

export default function SourcesAlert() {
  return (
    <div className={styles.overlayContainer}>
      <div className={styles.overlayContent}>
        
        <div className={styles.iconWrapper}>
          <IconDatabaseImport size={32} stroke={1.5} />
          <div className={styles.iconBadge}>
            <IconSparkles size={12} fill="currentColor" />
          </div>
        </div>

        <div className="flex flex-column gap-2">
          <h3 className={styles.title}>
            <FormattedMessage id="ai.sources.alert" />
          </h3>
          <p className={styles.description}>
            <FormattedMessage 
              id="ai.sources.alert.desc"
            />
          </p>
        </div>

        <Link
          className="btn btn-visito-primary w-100"
          to="/ai/website"
        >
          <FormattedMessage id="ai.sources.alert.button" />
        </Link>

      </div>
    </div>
  );
}
